import { STATUS_LABEL, PRIORITY_LABEL, TYPE_LABEL } from "@/lib/format";

const STATUS_STYLES = {
  open: "bg-red-50 text-red-700 border-red-100",
  in_progress: "bg-blue-50 text-blue-700 border-blue-100",
  resolved: "bg-emerald-50 text-emerald-700 border-emerald-100",
  overdue: "bg-amber-50 text-amber-800 border-amber-200",
};

const PRIORITY_STYLES = {
  urgent: "bg-rose-50 text-rose-700 border-rose-200",
  general: "bg-slate-50 text-slate-700 border-slate-200",
  routine: "bg-indigo-50 text-indigo-700 border-indigo-100",
};

export function StatusPill({ status, overdue, className = "" }) {
  const key = overdue ? "overdue" : status;
  const label = overdue ? "Overdue" : STATUS_LABEL[status] || status;
  return (
    <span
      data-testid={`status-pill-${key}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold ${STATUS_STYLES[key] || "bg-slate-50 text-slate-700"} ${className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${
        key === "open" ? "bg-red-500" :
        key === "in_progress" ? "bg-blue-500" :
        key === "resolved" ? "bg-emerald-500" :
        "bg-amber-500"
      }`} />
      {label}
    </span>
  );
}

export function PriorityPill({ priority, className = "" }) {
  return (
    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide ${PRIORITY_STYLES[priority] || "bg-slate-50 text-slate-700"} ${className}`}>
      {PRIORITY_LABEL[priority] || priority}
    </span>
  );
}

export function TypePill({ type, className = "" }) {
  return (
    <span className={`inline-flex items-center rounded-full border border-slate-200 bg-white px-2 py-0.5 text-[11px] font-medium text-slate-600 ${className}`}>
      {TYPE_LABEL[type] || type}
    </span>
  );
}
